import React, { useRef, useEffect } from 'react';
import {useUpdateEffect} from 'ahooks';
import Circle from './Circle';
import {registerEventGeometry} from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {data, property, label, style} = props;
    const featureRef = useRef();
    const { featureLayer, map } = useProps();

    useEffect(() => {
        let feature = new Circle({
            geometry: data,
            style,
            properties: property,
            label
        });

        // 注册事件
        registerEventGeometry(feature, props);

        if (featureLayer) {
            featureLayer.entities.add(feature);
        } else {
            map.entities.add(feature);
        }

        featureRef.current = feature;

        return () => {
            if (featureLayer) {
                featureLayer.entities.remove(feature);
            } else {
                map.entities.remove(feature);
            }
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [JSON.stringify(property)]);

    useUpdateEffect(() => {
        featureRef.current.setLabel(label);
    }, [JSON.stringify(label)]);

    useUpdateEffect(() => {
        featureRef.current.setStyle(style);
    }, [JSON.stringify(style)]);

    return <></>;
}
